export const ROUTES = {
  // Auth routes
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT: '/forgot',
  RESET: '/reset',
  VERIFY: '/verify',
  VERIFY_SUCCESS: '/verify-success',
  VERIFY_ALREADY_SUCCESS: '/verify-already-success',
  HELP: '/help',
  UNAUTHORIZED: '/401',
  MAINTENANCE: '/418',
  NOT_FOUND: '/404',

  // Brand routes
  BRAND: '/brand',
  BRAND_SUMMARY: '/brand/summary',
  BRAND_TIMELINE: '/brand/timeline',
  BRAND_TRAFFIC: '/brand/traffic',
  BRAND_QUANTITATIVE: '/brand/quantitative',

  // Performance routes
  PERFORMANCE_CENTER: '/performance/center',
  PERFORMANCE_PRODUCTS: '/performance/products',
  PERFORMANCE_CATEGORY: '/performance/category',
  PERFORMANCE_BUNDLES: '/performance/bundles',
  PERFORMANCE_SNS: '/performance/sns',

  // PPC routes
  PPC_OVERVIEW: '/ppc/overview',
  PPC_TIMELINE: '/ppc/Timeline',
  PPC_PRODUCTS: '/ppc/products',
  PPC_KEYWORDS_ANALYSIS: '/ppc/keywords/analysis',
  PPC_JOURNEY: '/ppc/journey',
  PPC_RESELLERS_BUYBOX: '/ppc/resellers/buybox',
  PPC_AUTOACOS: '/ppc/autoacos',
  PPC_PAID_MEDIA: '/ppc/paid-media',

  // Other routes
  PROMOTIONS_REPORTS: '/promotions/reports',
  CUSTOMER_GEOGRAPHY: '/customer/geography',
  INVITE_CLIENT: '/invite/client',
} as const;
